import { AfterViewInit, Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { AlertService } from '../../services/Alert/alert.service';
import { ApiService } from '../../services/API/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import 'owl.carousel'; 
import { Router } from '@angular/router';

@Component({
  selector: 'app-home-page-two',
  templateUrl: './home-page-two.component.html',
  styleUrls: ['./home-page-two.component.scss']
})
export class HomePageTwoComponent implements OnInit {

  menuItems: any[] = []
  offers: any[] = [];
  slides: any[][] = [];
  currentSlide = 0;
  featuredProducts: any[] = [];

  constructor(
    private alertService: AlertService,
    private apiService: ApiService,
    private router: Router
  ) { }

  showSuccess() {
    this.alertService.success('Operation completed successfully!');
  }

  showError() {
    this.alertService.danger('Something went wrong!');
  }

  ngOnInit(): void {
    this.getPopularProducts()
    this.getData()
    this.getHomePageSubCategory()
    this.getAllCategories()
  }

  calculateProductsPerSlide(): number {
    const width = window.innerWidth;
    if (width < 576) return 1;   // Mobile
    if (width < 768) return 2;   // Small tablets
    if (width < 992) return 2;   // Tablets
    if (width < 1200) return 4;  // Small desktop
    return 4;                    // Large desktop
  }

  getPopularProducts(){
    this.apiService.getHomePagePopularProducts().subscribe({
      next: response => {
        this.featuredProducts = response.data.data;
        console.log(this.featuredProducts);
        this.generateSlides();
      }, 
      error: (error: HttpErrorResponse) => {
        console.log(error);
        this.alertService.danger('Something went wrong!');
      }
    });
  }

  generateSlides() {
    const productsPerSlide = this.calculateProductsPerSlide();
    this.slides = [];
    for (let i = 0; i < this.featuredProducts.length; i += productsPerSlide) {
      this.slides.push(this.featuredProducts.slice(i, i + productsPerSlide));
    }
  }

  nextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
  }

  prevSlide() {
    this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
  }

  goToSlide(index: number) {
    this.currentSlide = index;
  }

  addToCart(product: any) {
    console.log('Added to cart:', product);
    // Add your cart logic here
  }

  // Get the appropriate product type URL
  getProductUrl(product: any): string {
    if (product.types && product.types.length > 0) {
      // If product has multiple types, navigate to product details with the first type
      // You can modify this logic based on your routing structure
      return `/product/${product.id}`;
    }
    return '#'; // Fallback URL
  }

  // Get the price to display (you might want to show min price or first type price)
  getDisplayPrice(product: any): string {
    if (product.types && product.types.length > 0) {
      // If product has multiple types, find the minimum price or show the first one
      const prices = product.types.map(t => t.price).filter(p => p > 0);
      if (prices.length > 0) {
        const minPrice = Math.min(...prices);
        return `$${minPrice.toFixed(2)}`;
      } else if (product.types[0].price === 0) {
        // Handle items with price 0 (like the Ziti & Broccoli Tray in your example)
        return '';
      }
    }
    return 'Contact for price';
  }

  // Navigate to product details
  viewProduct(product: any) {
    if (product.types && product.types.length > 0) {
      // Navigate to product detail page with product ID
      // You can pass additional data if needed
      this.router.navigate(['/product-details', product.id,product.name], {
        state: { product: product }
      });
    }
  }

  // Get the product type name for display
  getProductType(product: any): string {
    if (product.types && product.types.length > 0) {
      // If there's only one type, show its name
      if (product.types.length === 1) {
        return product.types[0].name;
      }
      // If multiple types, show the count
      return `${product.types.length} sizes available`;
    }
    return '';
  }

  showCarousel: boolean = false;
  getData() {
    this.apiService.getHomePageData().subscribe({
      next: response => {
        this.offers = response.data.ads;
      }, 
      error: (error: HttpErrorResponse) => {
        console.log(error);
        this.alertService.danger('Something went wrong!');
      }
    });
  }

  lunchCategoryId: any[] = []
  cateringCategoryId: any[] = []
  data: any
  cateringImage: string = ''
  lunchImage: string = ''
  getAllCategories(){
    this.apiService.getAllCategories().subscribe({
      next: response => {
        this.data = response.data
        this.cateringImage = this.data[1].avatar
        this.lunchImage = this.data[0].avatar
        this.lunchCategoryId = response.data.map(category => (category.name == 'Lunch' || category.name == 'Launch') == true ? category.id : null).filter(Boolean);
        this.cateringCategoryId = response.data.map(category => (category.name == 'Catering') == true ? category.id : null).filter(Boolean);
        // console.log(this.cateringCategoryId[0])
      }, 
      error: (error: HttpErrorResponse) => {
        console.log(error);
        this.alertService.danger('Something went wrong!');
      }
    });
  }

  getHomePageSubCategory(){
    this.apiService.getHomePageSubCategory().subscribe({
      next: response => {
        this.menuItems = response.data;
      }, 
      error: (error: HttpErrorResponse) => {
        console.log(error);
        this.alertService.danger('Something went wrong!');
      }
    });
  }

  lunchMenuItems: boolean = false
  cateringMenuItems: boolean = false
  showMenu(menu: string) {
    if(menu === 'lunch'){
      $('.lunchMenuItems-cateringMenuItems').addClass('d-none');
      $('.lunchMenuItems').removeClass('d-none');
      $('.cateringMenuItems').addClass('d-none');
      this.lunchMenuItems = true;
      this.cateringMenuItems = false;
    }
    else if(menu === 'catering'){
      $('.lunchMenuItems-cateringMenuItems').addClass('d-none');
      $('.cateringMenuItems').removeClass('d-none');
      $('.lunchMenuItems').addClass('d-none');
      this.cateringMenuItems = true;
      this.lunchMenuItems = false;
    }
  }

  showLunchCatringMenu(){
    $('.lunchMenuItems-cateringMenuItems').removeClass('d-none');
    $('.cateringMenuItems').addClass('d-none');
    $('.lunchMenuItems').addClass('d-none');
    this.lunchMenuItems = false;
    this.cateringMenuItems = false;
  }

  chunkArray(arr: any[], size: number): any[] {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  }

  // Function to calculate empty cells
  getEmptyCells(row: any[]): any[] {
    return Array(5 - row.length).fill(null);
  }
}